<div class="toast-overlay pointer-events-none">
  <ng-container *ngIf="groups$ | async as groups">
    <div
      class="stack"
      *ngFor="let pos of positions"
      [class.top-left]="pos==='top-left'"
      [class.top-center]="pos==='top-center'"
      [class.top-right]="pos==='top-right'"
      [class.bottom-left]="pos==='bottom-left'"
      [class.bottom-center]="pos==='bottom-center'"
      [class.bottom-right]="pos==='bottom-right'">
      <app-toast
        class="pointer-events-auto"
        *ngFor="let t of groups[pos]; trackBy: trackById"
        [toast]="t">
      </app-toast>
    </div>
  </ng-container>
</div>
